import { getStoreAccessors } from 'typesafe-vuex';
import { State } from './../state';
import { IAdminTablesState } from "./state";

export const getters = {
    getZones: (state: IAdminTablesState) => state.zones,
    getTables: (state: IAdminTablesState) => state.tables,
};

export const { read } = getStoreAccessors<IAdminTablesState, State>('');
export const readZones = read(getters.getZones);
export const readTables = read(getters.getTables);
